module.exports = __webpack_public_path__ + "img/blog2.9a4879c0.png";